import React from "react";

import Experience from "./experience.component";
import Certifications from "./certifications.component";
import Education from "./education.component";
import Projects from "./projects.component";
import Skills from "./skills.component";
import Achievement from "./achievements.component";
import Technologies from "./technologies.component";
import ToolsComponent from "./Tools.component";
import VolunteerExperienceComponent from "./volunteerexperience.component";
import Background from "./img/senura.jpg";

export default function Cv() {
  return (
    <div className="CVcomponent">
      <main class="page cv-page">
        {/* <section class="portfolio-block block-intro ">
          <div class="container">
            <div
              class="avatar"
              style={{
                backgroundImage: `url(${Background})`,
              }}
            ></div>
            <div class="about-me">
              <p>
                Hello! I am <strong>Senura Jayadeva</strong>. I am interested in
                web development, Machine Learning and IoT. Always curious about
                new things and enjoy learning.
              </p>
              <a class="btn btn-outline-primary" role="button" href="#">
                DOWNLOAD CV
              </a>
            </div>
          </div>
        </section> */}

        <hr id="HRCV" />

        <section class="portfolio-block cv">
          <div class="container">
            <Technologies />
            <ToolsComponent />
            <Projects />
            <Achievement />
            <Certifications />
            <VolunteerExperienceComponent />
            <Experience />
            <Education />

            <div class="group">
              <div class="row" style={{ padding: "5px" }}>
                <div
                  class="col-md-12 skills"
                  data-aos="zoom-in"
                  data-aos-delay="400"
                  data-aos-duration="600"
                  style={{
                    backgroundColor: "#333",
                    color: "white",
                    borderRadius: "20px",
                  }}
                >
                  <div class="contact-info portfolio-info-card">
                    <h2>Contact Info</h2>
                    <div class="row">
                      <div class="col-1">
                        <i class="icon ion-android-calendar icon"></i>
                      </div>
                      <div class="col-9">
                        <span>24/3/1998</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1">
                        <i class="icon ion-person icon"></i>
                      </div>
                      <div class="col-9">
                        <span>Senura Vihan Jayadeva</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1">
                        <i class="icon ion-ios-telephone icon"></i>
                      </div>
                      <div class="col-9">
                        <span>
                          {" "}
                          <a
                            href="tel:+94 77 914 2664"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            +94 77 914 2664
                          </a>
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-1">
                        <i class="icon ion-at icon"></i>
                      </div>
                      <div class="col-9">
                        <span>
                          <a
                            href="mailto:senurajayadeva@gmail.com"
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            senurajayadeva@gmail.com
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
